export const SET_M_INDIVIDUAL = 'modificaciones/SET_M_INDIVIDUAL';
export const SET_M_MASSIVE = 'modificaciones/SET_M_MASSIVE';
export const SET_SELECT_FORM = 'modificaciones/SET_SELECT_FORM';
export const SET_INSURANCE = 'modificaciones/SET_INSURANCE';
export const SET_INSURANCE_BY_EMPLOYEE_GROUP_COMPANY =
  'modificaciones/SET_INSURANCE_BY_EMPLOYEE_GROUP_COMPANY';

export const FETCH_M_INDIVIDUAL = 'modificaciones/FETCH_M_INDIVIDUAL';
export const FETCH_M_MASSIVE = 'modificaciones/FETCH_M_MASSIVE';
export const FETCH_INSURANCE = 'modificaciones/FETCH_INSURANCE';

export const TYPE_FORM = 'modificaciones/TYPE_FORM';
export const POST_MASSIVE_MODIFICATION =
  'modificaciones/POST_MASSIVE_MODIFICATION';
export const POST_M_INDIVIDUAL = 'modificaciones/POST_M_INDIVIDUAL';
export const POST_EXECUTE_MODIFICATION_INDIVIDUAL =
  'modificaciones/POST_EXECUTE_MODIFICATION_INDIVIDUAL';
export const CANCEL_MASSIVE_MODIFICATION =
  'modificaciones/CANCEL_MASSIVE_MODIFICATION';
export const CANCEL_MODIFICATION_INDIVIDUAL =
  'modificaciones/CANCEL_MODIFICATION_INDIVIDUAL';
export const EXECUTE_MASSIVE_MODIFICATION =
  'modificaciones/EXECUTE_MASSIVE_MODIFICATION';

export const GET_TYPE_FORM = 'modificaciones/GET_TYPE_FORM';
export const GET_M_INDIVIDUAL = 'modificaciones/GET_M_INDIVIDUAL';
export const GET_M_MASSIVE = 'modificaciones/GET_M_MASSIVE';
export const GET_INSURANCE_BY_EMPLOYEE_GROUP_COMPANY =
  'modificaciones/GET_INSURANCE_BY_EMPLOYEE_GROUP_COMPANY';
